import DefaultAttr from './default'
export default class RichTextBox extends DefaultAttr {
  richValue = ''
  constructor (args = {}) {
    super(args)
    this._.assign(this, args)
    // 挂载背景颜色
    this.setStyleSetting(args.type, this)
  }
}



// WEBPACK FOOTER //
// ./src/components/report/design/customPage/assets/js/richTextBox.js